import React, { useContext, useRef, useState } from "react";
import { UserData } from "../../../Context/DataContext";
import { Payment } from "./Payment";
import styles from "./styles/SubscriptionV2.module.css";
import "./styles/renewalModal.css";
import dayjs from "dayjs";
import config from "../../../config";
import { useEffect } from "react";
import { formatDate } from "../../../Utils/formatDate";
import { useLocation, useNavigate } from "react-router-dom";
import Confirmation from "../../Confirmation/Confirmation";
import {
  RetrieveKey,
  SetUpIntent,
  activateAutoRenewal,
  cancelStripeSubscription,
  createIbanPaymentMethod,
  fetchStripeProducts,
  getStripeCardDetails,
} from "../../../Utils/StripeUtils";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { PaymentSuccess } from "./PaymentSuccess";
import Loading from "../../Loading/Loading";
import { ReactComponent as DangerTriangle } from "./styles/img/DangerTriangle.svg";
import { ReactComponent as Calendar } from "./styles/img/Calendar.svg";
import { AddNewPlan } from "./AddNewPlan";
import { Button, Checkbox, Modal, Input, Form } from "antd";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { submitCaptcha } from "../../../Utils/captcha";
import useSubscriptionData from "../../../Utils/useSubscriptionData";
import { floatMessage } from "../../../Utils/floatMessage";
const base_url = config.base_url;
function Subscription({
  scrolltoPayment = false,
  subscriptionRenewal = false,
}) {
  const paymentRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const userData = UserData();
  const [expand, setExpanded] = useState(false);
  const [storageEdit, setStorageEdit] = useState();
  const [cardDetails, setCardDetails] = useState();

  const [modal, showmodal] = useState(false);
  const [stripePromise, setStripePromise] = useState();
  const [clientSecret, setClientSecret] = useState();
  const [openRenewModal, setOpenRenewModal] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [showCouponSection, setShowCouponSection] = useState(false);
  const [codeAvailableOtherPlan, setCodeAvailableOtherPlan] = useState(false);
  const [couponSuccess, setCouponSuccess] = useState(false);
  const [couponError, setCouponError] = useState(false);
  const [appliedCouponData, setAppliedCouponData] = useState(undefined);
  const [applybuttonLoading, setApplyButtonLoading] = useState(false);
  const [ibanData, setIbanData] = useState();
  const [checkTermsAndPrivacyCheckbox, setCheckTermsAndPrivacyCheckbox] =
    useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.Subscription
  );
  const [couponContent, setCouponContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ChoosePlan
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );

  const [ibanChangingError, setIbanChangingError] = useState(false);
  const [showChangeIban, setshowChangeIban] = useState(false);
  const [loadingChangeIban, setLoadingChangeIban] = useState(false);
  const [ibanForm] = Form.useForm();
  const subscriptionData = useSubscriptionData(dublicatedcontent);

  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.Subscription);
    setCouponContent(websiteCurrentLang.content.User.MyAccount.ChoosePlan);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const [couponErrorMessage, setCouponErrorMessage] = useState(
    couponContent.choosePlanText15
  );
  useEffect(() => {
    RetrieveKey()
      .then((key) => {
        setStripePromise(loadStripe(key));
      })
      .catch((e) => console.log(e));
  }, []);
  useEffect(() => {
    SetUpIntent()
      .then((secret) => setClientSecret(secret))
      .catch((e) => console.log(e));
  }, []);

  const validateCoupun = async (couponCode) => {
    if (!couponCode) return;
    setApplyButtonLoading(true);
    const token = await submitCaptcha();
    await fetch(base_url + "user/supercode/validate", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      body: `code=${couponCode}&token=${token}`,
      credentials: "include",
    })
      .then((res) => {
        if (res.status === 498 || res.status === 500) {
          setApplyButtonLoading(false);
          setCouponErrorMessage("Please try again later");
          setCouponError(true);
          throw res;
        }
        return res.json();
      })
      .then((res) => {
        if (res.valid === false && res.payment === true) {
          setCouponError(true);
          setCouponErrorMessage(
            "Please apply this coupon while purchasing the plan"
          );
          throw res;
        } else if (res.valid === false) {
          setCouponError(true);
          setCouponErrorMessage(dublicatedcontent.dublicatedText271);
          throw res;
        }
      })
      .then(async () => {
        const token2 = await submitCaptcha();
        return fetch(base_url + "user/supercode/apply", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          body: `code=${couponCode}&token=${token2}`,
          credentials: "include",
        });
      })
      .then((res) => {
        if (res.status !== 200) {
          setCouponSuccess(false);
          throw res;
        }
        return res.json();
      })
      .then(async (res) => {
        await userData.getBillingData();
        await userData.getCustomerUser();
        setCouponSuccess(true);
        setApplyButtonLoading(false);
        setAppliedCouponData(res);

        setTimeout(() => {
          setCouponSuccess(false);
        }, 3000);
      })
      .catch((err) => {
        setApplyButtonLoading(false);
      });
    // setApplyButtonLoading(true);
  };
  const convertBytesToReadable = (bytes) => {
    const units = ["B", "KB", "MB", "GB"];
    let i = 0;
    while (bytes >= 1024 && i < units.length - 1) {
      bytes /= 1024;
      i++;
    }
    return `${bytes.toFixed(2)} ${units[i]}`;
  };

  const getCardDetails = () => {
    getStripeCardDetails()
      .then((res) => {
        if (res.status !== 200) setCardDetails({ error: true });
        else {
          res.json().then((e) => {
            setCardDetails(e);
          });
        }
      })
      .catch((e) => {
        console.log("Unable to get card details");
      });
  };

  useEffect(() => {
    if (
      userData?.BillingData?.plan === "free" &&
      location.pathname !== "/user/plan"
    ) {
      // To cancel the redirections
      return;
      return navigate("/user/plan", {
        replace: true,
        state: { default_years: 3 },
      });
      showmodal(
        <PaymentSuccess
          title={dublicatedcontent?.you_are_subscribed_free_plan}
          subtitle={dublicatedcontent?.please_select_plan}
          button={dublicatedcontent?.select_plan}
          OnClose={() => {
            navigate("/user/plan", { replace: true });
          }}
        />
      );
    }
    // const Weglot = document.createElement("script")
    // Weglot.src = "https://cdn.weglot.com/weglot.min.js"
    // document.body.appendChild(Weglot)
    // Weglot.onload = () =>{
    //   console.log('Script is loaded')
    //   window.Weglot.initialize({
    //     api_key: 'wg_fe59e91dbf7c41abd8908f1b88215ff17',
    //   });
    // }
  }, [userData?.BillingData]);

  useEffect(() => {
    getCardDetails();
  }, []);

  // ============================ hardcode ==============================
  const storageSize = 1073741824; // 1 GB
  const usedStorage = userData.CustomerUser.used_storage;
  const usedPercent = Math.ceil((usedStorage * 100) / storageSize);

  const oneGigabyteCost = "10.00";

  const [amount, setAmount] = useState(1);

  const increaseAmount = () => {
    setAmount((prevAmount) => prevAmount + 1);
  };

  const decreaseAmount = () => {
    if (amount > 1) {
      setAmount((prevAmount) => prevAmount - 1);
    }
  };

  const saveStorage = () => {
    setStorageEdit(false);
    // save storage
  };

  const multiplyAndFormatCurrency = (storage, price) => {
    const result = storage * price;
    return result.toFixed(2);
  };
  const cancelSubscription = () => {
    cancelStripeSubscription()
      .then((res) => {
        if (res.status === 200) {
          userData.getBillingData();
          showmodal(null);
        } else return;
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const updateIbanPayment = async () => {
    //we would need to get the IBAN number and name associated with the IBAN
    if (ibanChangingError) return;
    setLoadingChangeIban(true);
    const stripe_key = await RetrieveKey();
    const stripe = await loadStripe(stripe_key);
    const setup_intent = await SetUpIntent("sepa_debit");
    const iban_number = ibanData?.iban_number;
    const iban_customer_name = ibanData?.account_owner_name;
    const email = userData?.BillingData?.email;
    let payment_method;
    createIbanPaymentMethod(stripe, iban_number, {
      name: iban_customer_name,
      email,
    })
      .then(async (paymentMethod) => {
        if (paymentMethod.error) {
          throw paymentMethod.error;
        }

        payment_method = paymentMethod;
        return stripe.confirmSepaDebitSetup(setup_intent, {
          payment_method: payment_method?.paymentMethod?.id,
        });
      })
      .then(async (res_data) => {
        if (res_data.error) {
          throw res_data.error;
        }
        await fetch(base_url + "user/payment/update", {
          method: "POST",
          mode: "cors",
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
          body: `paymentMethod=${payment_method?.paymentMethod?.id}`,
        })
          .then((res) => {
            if (res.status !== 200) {
              throw res;
            }
          })
          .catch((err) => {
            throw err;
          });
      })
      .then(async () => {
        await getStripeCardDetails()
          .then((res) => {
            if (res.status !== 200) setCardDetails({ error: true });
            else {
              res.json().then((e) => {
                setCardDetails(e);
              });
            }
          })
          .catch((e) => {
            console.log("Unable to get card details");
          });
        setshowChangeIban(false);
        floatMessage(dublicatedcontent?.saved);
        setIbanChangingError(false);
        ibanForm.resetFields();
      })
      .catch((err) => {
        console.log(err);
        setIbanChangingError(true);
      })
      .finally(() => {
        setLoadingChangeIban(false);
      });
  };
  const ScrollOpenwPaymentMethod = () => {
    setExpanded(true);
    paymentRef?.current?.scrollIntoView({
      behaviour: "smooth",
      block: "start",
    });
  };
  useEffect(() => {
    if (scrolltoPayment) ScrollOpenwPaymentMethod();
  }, [scrolltoPayment]);
  useEffect(() => {
    if (subscriptionRenewal) setOpenRenewModal(true);
  }, [subscriptionRenewal]);
  useEffect(() => {
    if (openRenewModal) {
      // Set the body width to account for the missing scrollbar
      document.documentElement.style.overflow = "hidden";
      return () => {
        document.documentElement.style.overflow = "unset";
      };
    }
  }, [openRenewModal]);

  return (
    <div className={styles.main}>
      <div className={styles.title}>{content.subscriptionText4}</div>
      <div className={styles.rect} />
      <div className={styles.status_div}>
        {!(
          userData?.BillingData?.plan === "free" &&
          location.pathname !== "/user/plan"
        ) &&
          +subscriptionData?.years !== 100 && (
            <>
              {userData?.BillingData?.expired_payment_method &&
              userData?.BillingData?.nextCharge <
                Date.now() + 3 * 31 * 24 * 60 * 60 * 1000 ? (
                <div className={styles.renew_notification}>
                  <DangerTriangle />
                  <p>{dublicatedcontent?.update_payment_details}</p>
                  <p
                    style={{
                      cursor: "pointer",
                      color: "#0091EA",
                    }}
                    onClick={(e) => ScrollOpenwPaymentMethod()}
                  >
                    {dublicatedcontent?.click_here_to_update}
                  </p>
                </div>
              ) : !userData?.BillingData?.cancel ? (
                <button
                  disabled={userData.isFreezed}
                  onClick={() => {
                    if (!userData?.BillingData?.cancel)
                      return showmodal(
                        <Confirmation
                          OnConfirm={() => {
                            cancelSubscription();
                          }}
                          onClose={() => showmodal(null)}
                          cancel_button={dublicatedcontent?.dublicatedText102}
                          confirm_button={dublicatedcontent?.dublicatedText101}
                          title={dublicatedcontent?.confirm}
                          text={content?.subscriptionText5}
                          confirm_color="#0091EA"
                        />
                      );
                    // else productsRef.current?.scrollIntoView({behavior: "smooth" })
                    else navigate("/user/plan", { replace: true });
                  }}
                  className={
                    userData?.BillingData?.cancel
                      ? styles.resume_button
                      : styles.cancel_button
                  }
                >
                  {content?.subscriptionText7}
                </button>
              ) : (
                <div className={styles.renew_notification}>
                  <DangerTriangle />
                  <p>
                    {dublicatedcontent?.auto_renewal_is_canceled?.replace(
                      "next_charge",
                      formatDate(userData?.BillingData?.nextCharge).split(
                        " "
                      )[0]
                    )}
                  </p>
                  <p
                    style={{
                      cursor: "pointer",
                      color: "#0091EA",
                    }}
                    onClick={(e) => {
                      setOpenRenewModal(true);
                    }}
                  >
                    {dublicatedcontent?.click_here_to_renew}
                  </p>
                </div>
              )}
            </>
          )}
        <div className={styles.status_table}>
          <div className={styles.status_row}>
            <span className={styles.status_bold}>
              {content.subscriptionText8}:{" "}
            </span>
            {dublicatedcontent[userData?.BillingData?.status?.toLowerCase()]}
          </div>
          <div className={styles.status_row}>
            <span className={styles.status_bold}>
              {content.subscriptionText9}:&nbsp;
            </span>{" "}
            {(
              subscriptionData?.metadata?.[
                `${websiteCurrentLang?.label}_name`
              ] ||
              dublicatedcontent[`${subscriptionData?.name}`] ||
              dublicatedcontent[
                `${subscriptionData?.name?.toLowerCase()}_subscription`
              ] ||
              subscriptionData?.name
            )?.toUpperCase()}
          </div>
          {!subscriptionData?.metadata?.lifetime && (
            <div className={styles.status_row}>
              <span className={styles.status_bold}>
                {content.subscriptionText10}:&nbsp;
              </span>{" "}
              {subscriptionData?.price
                ? `${dublicatedcontent?.price_format
                    ?.replace("currency_", userData?.currency?.symbol)
                    ?.replace(
                      "amount_",
                      subscriptionData?.price.toFixed(2)
                    )} / ${
                    subscriptionData.name === "Monthly"
                      ? dublicatedcontent.month
                      : `${
                          +subscriptionData?.years > 1
                            ? subscriptionData?.years
                            : ""
                        } ${subscriptionData?.yearsText?.toLowerCase()}`
                  }`
                : ""}
            </div>
          )}
          <div className={styles.status_row}>
            <span className={styles.status_bold}>
              {content.subscriptionText11}:&nbsp;
            </span>
            {
              formatDate(
                userData?.BillingData?.date,
                websiteCurrentLang.label
              ).split(" ")[0]
            }
          </div>
          {!subscriptionData?.metadata?.lifetime && (
            <div className={styles.status_row}>
              <span
                className={styles.status_bold}
                style={{
                  paddingRight: "5px",
                }}
              >
                {userData?.BillingData?.cancel
                  ? content.subscriptionText12
                  : userData?.BillingData.plan === "free"
                  ? dublicatedcontent.end_of_trial
                  : content.subscriptionText24}
                :&nbsp;
              </span>
              {userData?.BillingData.plan !== "subscribed" &&
                (userData?.BillingData?.nextCharge
                  ? formatDate(
                      userData?.BillingData?.nextCharge,
                      websiteCurrentLang.label
                    ).split(" ")[0]
                  : "")}
              {userData?.BillingData.plan === "subscribed" &&
                userData?.BillingData?.nextCharge &&
                (websiteCurrentLang.label === "en"
                  ? dayjs(userData?.BillingData?.nextCharge).format(
                      "YYYY/MM/DD"
                    )
                  : dayjs(userData?.BillingData?.nextCharge).format(
                      "DD/MM/YYYY"
                    ))}
              {/* ? formatTime(userData?.BillingData?.nextCharge)
                                  : formatTime(userData?.BillingData?.nextCharge) */}
            </div>
          )}
        </div>
        <div
          onClick={(e) => {
            setCouponError(false);
            setCouponSuccess(false);
            setCouponCode(undefined);
            setShowCouponSection(!showCouponSection);
          }}
          className={styles.couponWrapper}
        >
          <p>{couponContent.choosePlanText13}</p>
          {showCouponSection ? (
            <CaretUpOutlined
              style={{
                color: "#0091EA",
              }}
            />
          ) : (
            <CaretDownOutlined
              style={{
                color: "#0091EA",
              }}
            />
          )}
        </div>
        {showCouponSection && (
          <div>
            <div className={styles.couponSection}>
              <Input
                onChange={(e) => {
                  setCouponError(false);

                  setCouponSuccess(false);
                  setCouponCode(e.target.value);
                }}
                placeholder={dublicatedcontent?.insert_your_coupon_code}
                className={styles.couponInput}
                style={{
                  height: "46px",
                  width: "256px",
                }}
              />
              <Button
                disabled={!couponCode}
                loading={applybuttonLoading}
                onClick={(e) => {
                  validateCoupun(couponCode);
                }}
                className={styles.couponApply}
                style={
                  applybuttonLoading
                    ? {
                        width: "130px",
                      }
                    : { width: "fit-content" }
                }
              >
                {couponContent.choosePlanText14}
              </Button>
            </div>
            {couponError && (
              <p
                style={{
                  color: "#FF0000",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {couponErrorMessage}
              </p>
            )}
            {codeAvailableOtherPlan && (
              <p
                style={{
                  color: "#FF0000",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {dublicatedcontent?.code_not_available_for_this_plan}
              </p>
            )}

            {couponSuccess && !appliedCouponData?.expiration_date && (
              <p
                style={{
                  color: "#419F23",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {dublicatedcontent.dublicatedText272}
              </p>
            )}
            {couponSuccess && appliedCouponData?.expiration_date && (
              <p
                style={{
                  color: "#419F23",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {dublicatedcontent.dublicatedText273}
                {websiteCurrentLang.label === "en"
                  ? dayjs(appliedCouponData.expiration_date).format(
                      "YYYY-MM-DD"
                    )
                  : dayjs(appliedCouponData.expiration_date).format(
                      "DD/MM/YYYY"
                    )}
              </p>
            )}
          </div>
        )}
        {/* Renew notification (THIS IS A NORMAL COMMENT, JUST DON"T INLCUDE IT IN THE CODE) */}

        {openRenewModal && (
          <Modal
            open={openRenewModal}
            onCancel={(e) => {
              setOpenRenewModal(false);
            }}
            afterOpenChange={(e) => {
              if (e === false) {
                setCheckTermsAndPrivacyCheckbox(false);
              }
            }}
            className="autoRenew_modal"
            footer={[
              <div className={styles.modalFooter}>
                <Button
                  onClick={() => {
                    activateAutoRenewal().then(() => {
                      userData.getBillingData();
                      setOpenRenewModal(false);
                    });
                  }}
                  disabled={!checkTermsAndPrivacyCheckbox}
                  className={styles.modalConfirmButton}
                >
                  {dublicatedcontent?.confirm}
                </Button>
                <Button
                  onClick={(e) => {
                    setOpenRenewModal(false);
                  }}
                  className={styles.modalCloseButton}
                >
                  {dublicatedcontent?.dublicatedText76}
                </Button>
              </div>,
            ]}
          >
            <div className={styles.autoRenew_modal_container}>
              <h2 className={styles.autoRenew_modal_title}>
                {content?.update_auto_renewal}
              </h2>
              <div className={styles.autoRenew_modal_containerDivider}></div>
              <div
                className={styles.autoRenew_modal_container_contentContainer}
              >
                <div
                  style={{
                    width: "20%",
                  }}
                >
                  <Calendar />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                  }}
                >
                  <div
                    className={
                      styles.autoRenew_modal_container_contentContainer_left
                    }
                  >
                    <span>{content.subscriptionText9}:</span>
                    {!subscriptionData?.metadata?.lifetime && (
                      <span>{content.subscriptionText10}:</span>
                    )}
                    <span>{content.subscriptionText11}:</span>
                    <span>{content.subscriptionText12}:</span>
                  </div>
                  <div
                    className={
                      styles.autoRenew_modal_container_contentContainer_right
                    }
                  >
                    <span>
                      {(
                        subscriptionData?.metadata[
                          `${websiteCurrentLang?.label}_name`
                        ] ||
                        dublicatedcontent[
                          `${subscriptionData?.name?.toLowerCase()}_subscription`
                        ] ||
                        subscriptionData?.name
                      )?.toUpperCase()}
                    </span>
                    <span>{`${dublicatedcontent?.price_format
                      ?.replace("currency_", userData?.currency?.symbol)
                      ?.replace("amount_", subscriptionData?.price)}/${
                      dublicatedcontent?.year
                    }`}</span>
                    <span>
                      {formatDate(userData?.BillingData?.date).split(" ")[0]}
                    </span>
                    <span>
                      {
                        formatDate(userData?.BillingData?.nextCharge).split(
                          " "
                        )[0]
                      }
                    </span>
                  </div>
                </div>
              </div>
              <Checkbox
                onChange={(e) => {
                  setCheckTermsAndPrivacyCheckbox(e.target.checked);
                }}
                checked={checkTermsAndPrivacyCheckbox}
                // style={{
                //   width: "70%",
                // }}
              >
                <span>{dublicatedcontent?.by_checking_this_box_you_agree}</span>
              </Checkbox>
              <div>
                <a href="/terms-and-conditions" target="_blank">
                  {dublicatedcontent?.dublicatedText38}
                </a>
                ,
                <a href="/privacy-policy" target="_blank">
                  {" "}
                  {dublicatedcontent?.dublicatedText39}
                </a>
              </div>
            </div>
          </Modal>
        )}
      </div>
      <div className={styles.rect} />{" "}
      <div className={styles.subtitle}>{content?.subscriptionText14}</div>
      <div className={styles.storage_container}>
        <div className={styles.storage_left}>
          <div className={styles.storage_text}>
            {content.subscriptionText15}{" "}
            <span className={styles.storage_size}>
              {convertBytesToReadable(parseInt(storageSize))}{" "}
            </span>
            {content.subscriptionText16}{" "}
            {convertBytesToReadable(
              parseInt(userData.CustomerUser.used_storage)
            )}
            .
          </div>
          <div className={styles.status_bar}>
            <div
              className={styles.progress}
              style={{ minWidth: "5%", width: `${usedPercent}%` }}
            >
              {usedPercent}%
            </div>
          </div>
        </div>
        {/* {!storageEdit &&
            // <div className={styles.buttons_div}>
            //     <button disabled={userData.isFreezed} onClick={() => { setStorageEdit(true) }} className={styles.add_storage}>Add Storage</button>
            // </div>
        } */}
      </div>
      {userData.BillingData.plan !== "subscribed" && (
        <>
          {storageEdit && (
            <div className={styles.storage_edit}>
              <div className={styles.subtitle}>
                {content.subscriptionText17}
              </div>
              <div className={styles.storage_text}>
                {content.subscriptionText18}
              </div>

              <div className={styles.calculator}>
                <span
                  className={styles.minus_btn}
                  onClick={decreaseAmount}
                ></span>
                <input
                  type="number"
                  className={styles.storage_qty}
                  value={amount}
                  onChange={(e) =>
                    setAmount(Math.max(1, parseInt(e.target.value)))
                  }
                />
                <span
                  className={`${styles.minus_btn} ${styles.plus_btn}`}
                  onClick={increaseAmount}
                ></span>
              </div>

              <div className={styles.storage_total}>
                Total: {amount} GB * ${oneGigabyteCost} ={" "}
                {multiplyAndFormatCurrency(amount, oneGigabyteCost)} /{" "}
                {dublicatedcontent?.year}
              </div>

              <div className={styles.storage_text}>
                {content.subscriptionText19}
              </div>

              <div className={styles.storage_actions}>
                <div
                  onClick={() => {
                    setStorageEdit(false);
                  }}
                  className={styles.cancel_storage}
                >
                  {content.subscriptionText20}
                </div>
                <div
                  onClick={() => {
                    saveStorage();
                  }}
                  className={styles.add_storage}
                >
                  {content.subscriptionText21}
                </div>
              </div>
            </div>
          )}
          {userData?.BillingData?.plan.toLowerCase() !== "subscribed" &&
            userData?.BillingData?.plan.toLowerCase() !== "free" && (
              <div>
                <div ref={paymentRef} className={styles.rect} />

                <div className={styles.subtitle}>
                  {content.subscriptionText22}
                </div>

                <div className={styles.payment_div}>
                  {cardDetails?.card && (
                    <Payment cardDetails={cardDetails} expanded={expand} />
                  )}
                  {cardDetails?.sepa_debit && (
                    <>
                      {!showChangeIban && (
                        <Form.Item
                          style={{
                            marginTop: "10px",
                          }}
                          className={styles.form_container}
                          labelCol={{ span: 24 }}
                          label={dublicatedcontent.current_iban}
                        >
                          <div className={styles.ibanContainer}>
                            <div
                              style={{
                                padding: "10px",
                                borderRadius: "8px",
                                flex: "1",
                              }}
                              className={styles.iban_input}
                            >
                              XXXXXX{cardDetails?.sepa_debit?.last4}
                            </div>
                            {+subscriptionData?.years !== 100 && (
                              <div
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: "#0091ea",
                                }}
                                onClick={() => {
                                  setshowChangeIban(true);
                                }}
                              >
                                {dublicatedcontent.changeIban}
                              </div>
                            )}
                          </div>
                        </Form.Item>
                      )}

                      {showChangeIban && (
                        <Form
                          form={ibanForm}
                          onFinish={updateIbanPayment}
                          style={{
                            marginTop: "10px",
                          }}
                        >
                          <Form.Item
                            labelCol={{ span: 24 }}
                            name="account_owner_name"
                            label={dublicatedcontent.dublicatedText165}
                            rules={[
                              {
                                required: true,
                              },
                            ]}
                            required
                            className={`${styles.formItemContainer} ${styles.form_container}`}
                          >
                            <Input
                              value={ibanData?.account_owner_name}
                              onChange={(e) =>
                                setIbanData({
                                  ...ibanData,
                                  account_owner_name: e?.target?.value,
                                })
                              }
                              className={styles.iban_input}
                              placeholder={dublicatedcontent.dublicatedText268}
                            />
                          </Form.Item>
                          <div
                            style={{
                              position: "relative",
                            }}
                          >
                            <Form.Item
                              className={styles.form_container}
                              labelCol={{ span: 24 }}
                              name="iban"
                              label="IBAN"
                              rules={[
                                {
                                  required: true,
                                },
                              ]}
                              required
                            >
                              <Input
                                value={ibanData?.iban_number}
                                onChange={(e) => {
                                  setIbanData({
                                    ...ibanData,
                                    iban_number: e?.target?.value,
                                  });
                                  setIbanChangingError(false);
                                }}
                                className={styles.iban_input}
                                placeholder={dublicatedcontent.new_iban}
                              />
                            </Form.Item>{" "}
                            {ibanChangingError && (
                              <p className={styles.error_message_iban}>
                                {dublicatedcontent.iban_change_error}
                              </p>
                            )}
                          </div>
                          <div className={styles.buttons_container}>
                            <div
                              className={styles.hide_iban_button}
                              onClick={() => {
                                ibanForm.resetFields();
                                setshowChangeIban(false);
                              }}
                            >
                              {dublicatedcontent.dublicatedText184}
                            </div>
                            <Button
                              loading={loadingChangeIban}
                              className={styles.change_iban_button}
                              onClick={() => {
                                ibanForm.submit();
                              }}
                            >
                              {dublicatedcontent.changeIban}
                            </Button>
                          </div>
                        </Form>
                      )}
                    </>
                  )}
                </div>
              </div>
            )}
        </>
      )}
      <div className={styles.rect} />
      <div className={styles.plans_div}>
        <div className={styles.subtitle}>{content.subscriptionText23}</div>
        <AddNewPlan />
        {/* </Elements>} */}
      </div>
      {modal && modal}
    </div>
  );
}
export { Subscription };
